import { makeAction, makeReducer } from '@finn-no/redux-actions';
import Router from 'next/router';
import querystring from 'querystring';
import { getApiUrl } from '@/api/apiUrl';
import { fetchOffersForHotel } from '@/api/fetcher';
import { ApiActionStatus, type HotelOffersResponse, type ThunkResult } from '@/interfaces';
import { filtersToApiQueryParams, filtersToBrowserQueryParams } from '@/lib/utils/queryParamFilterConversions';
import defaultState from './defaultState';

export const actions = {
    setPending: makeAction<HotelOffersResponse>('HOTEL_RESULT_PENDING', (state) => ({
        ...state,
        status: ApiActionStatus.PENDING,
    })),
    setResults: makeAction<HotelOffersResponse>('HOTEL_RESULT_OK', (_, action) => ({
        ...defaultState.hotelResults,
        ...action.payload,
        status: ApiActionStatus.OK,
    })),
    setError: makeAction<HotelOffersResponse>('HOTEL_RESULT_ERROR', (state) => ({
        ...state,
        status: ApiActionStatus.ERROR,
    })),
};

export const fetchHotelResults =
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        (payload?: any): ThunkResult<Promise<void>> =>
        async (dispatch, getState): Promise<void> => {
            dispatch(actions.setPending());
            const queryParams = querystring.stringify(filtersToBrowserQueryParams(getState().filters));
            await Router.replace({ pathname: Router.pathname, query: queryParams }, undefined, { shallow: true });
            try {
                const data = await fetchOffersForHotel(getApiUrl(), filtersToApiQueryParams({ ...getState().filters, ...payload }));
                dispatch(actions.setResults(data));
            } catch {
                dispatch(actions.setError());
            }
        };

export const fetchHotelResultsToAppend =
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        (payload?: any): ThunkResult<Promise<void>> =>
        async (dispatch, getState): Promise<void> => {
            dispatch(actions.setPending());
            const topOffers = getState().hotelResults.offers;
            try {
                const data = await fetchOffersForHotel(getApiUrl(), filtersToApiQueryParams({ ...getState().filters, ...payload }));
                const { offers, ...newHotelResults } = data;
                // Append the new offers to the previous (top) offers.
                const appendedOffers = [...topOffers, ...offers];
                dispatch(actions.setResults({ ...newHotelResults, offers: appendedOffers }));
            } catch {
                dispatch(actions.setError());
            }
        };

export default actions;
export const hotelResultReducer = makeReducer<HotelOffersResponse>(actions);
